'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _TextInput = require('./TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _components = {
	_$FilterInput: {
		displayName: 'FilterInput'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var FilterInput = (function (_React$Component) {
	_inherits(FilterInput, _React$Component);

	function FilterInput() {
		_classCallCheck(this, _FilterInput);

		_React$Component.apply(this, arguments);
	}

	FilterInput.prototype.render = function render() {
		return _react2['default'].createElement(_TextInput2['default'], _extends({}, this.props, { clearable: true }));
	};

	_createClass(FilterInput, null, [{
		key: 'filterDelay',
		value: true,
		enumerable: true
	}]);

	var _FilterInput = FilterInput;
	FilterInput = _wrapComponent('_$FilterInput')(FilterInput) || FilterInput;
	return FilterInput;
})(_react2['default'].Component);

exports['default'] = FilterInput;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/FilterInput.js
 ** module id = 1034
 ** module chunks = 1
 **/